import { colors } from 'baseui/tokens';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody } from 'components/common/drawer/styles';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { Container } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { OtherContainer, TotalContent, TotalItemContent } from '../../style';
import { HotelRescheduleFormType } from '../form-type';
import useRecalculate, {
  calculateRescheduleHotel,
  calculateRescheduleHotelAddOns,
} from '../hooks/use-recalculate';

interface Props {
  onClose: () => void;
}

export default function SummaryDrawer(props: Props) {
  const { t } = useTranslation();
  const { onClose } = props;
  const { getValues } = useFormContext<HotelRescheduleFormType>();
  const hotelSales = getValues('hotelSales');
  const total = useRecalculate();

  return (
    <>
      <DrawerHeader
        onClose={onClose}
        title={t('ticketSales:hotel_sale_details')}
      />
      <DrawerBody>
        {hotelSales.map((schedule, idx) => {
          if (!schedule.isSelected) {
            return null;
          }
          const hotelPrice = calculateRescheduleHotel(schedule.hotelSaleHotels);
          const addOnsPrice = calculateRescheduleHotelAddOns(
            schedule.hotelSaleAddOns,
          );
          const total = hotelPrice + addOnsPrice;
          return (
            <React.Fragment key={schedule.customId}>
              <Container style={{ height: 'auto' }}>
                <Text
                  variant="LabelMedium"
                  $style={{ color: stylesColors.primaryDefault }}
                >
                  {t('ticketSales:schedule_extra', {
                    extra: `${idx + 1} - ${schedule.bookingCode}`,
                  })}
                </Text>
                <Separator gap={16} />
                <OtherContainer>
                  <Text variant="LabelSmall">{t('common:reschedule')}</Text>
                  <Text variant="LabelSmall">{`Rp ${string2money(
                    total,
                  )}`}</Text>
                </OtherContainer>
              </Container>
              <Separator gap={24} />
            </React.Fragment>
          );
        })}
        <Separator gap={16} direction="vertical">
          <div style={{ height: 1, backgroundColor: colors.gray200 }} />
        </Separator>
        <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:total')}:</Text>
            <Separator gap={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(total)}`}</Text>
          </TotalItemContent>
        </TotalContent>
      </DrawerBody>
    </>
  );
}
